import { CallDetailsFragment } from "@/graphql/generated/graphql";

export const calculateReadingTime = (
  transcription: CallDetailsFragment["transcription"] | null
): number | undefined => {
  if (!transcription?.content?.utterances) {
    return;
  }

  let totalWords = 0;

  if (transcription.wordsCount) {
    totalWords = transcription.wordsCount;
  } else {
    transcription.content.utterances.forEach((word) => {
      if (word?.entries) {
        totalWords += word.entries.length;
      }
    });
  }

  return Math.round(totalWords / 200) || 1;
};
